export default {
  'primary-newsletter-button-cta-label': 'Subscribe',
  'primary-newsletter-tittle': 'Subscribe to Epic React',
  'primary-newsletter-byline':
    'Get the latest tutorials, articles, tips and announcements delivered to your inbox.',
  'sale-banner-cta-label': 'Buy Now',
}
